import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ImgDropzone from '../../../../Components/ImgDropzone/ImgDropzone';

function ColourImageDropZone({ showImageUpload, childRef, handleImageUpload, srcImage, isNewUploaded, oldAndNewImage }) {
  const { t } = useTranslation('common');

  return (
    <Modal className="common-custom-modal modal-large " show={showImageUpload} backdrop="static">
      <Modal.Header>
        <Modal.Title className="f-24">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_IMAGE_DROP_ZONE.UPLOAD_IMAGE')}</Modal.Title>
        <span onClick={() => handleImageUpload(close)} className="icon-close cursor-pointer" />
      </Modal.Header>

      <Modal.Body>
        <div className="modal-body">
          <ImgDropzone
            ref={childRef}
            onSubmit={handleImageUpload}
            acceptedFileExtenstion=".jpeg,.png,.jpg"
            image={srcImage()}
            isEditMode={!isNewUploaded}
            fromColour={oldAndNewImage()}
            title={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_IMAGE_DROP_ZONE.COLOUR')}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ColourImageDropZone;
